import { PreviousExitDetails } from '../types';

/**
 * Extracts the first share class ID from previousExitDetails
 */
export const getShareClassIdFromPrevious = (
  previousExitDetails: PreviousExitDetails | undefined,
  isEditMode: boolean,
): string | undefined => {
  if (!isEditMode || !previousExitDetails?.shareConsiderationShareClassIds)
    return undefined;

  return previousExitDetails.shareConsiderationShareClassIds[0];
};
